/**
 * Små hjälpare kring DOM-uppslag.
 *
 * Under `strict` returnerar `querySelector` alltid `T | null`, och det är
 * precis den nullen som är buggkällan i den här sortens kod. I stället för
 * att sprida `if (!x) return` överallt skiljer vi på två fall:
 * `find` för det som får saknas, `require` för det som inte får det.
 */

export function find<T extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): T | null {
  return scope.querySelector<T>(selector);
}

export function findAll<T extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): T[] {
  return Array.from(scope.querySelectorAll<T>(selector));
}

/** Kastar om elementet saknas. Använd bara när markupen garanterar det. */
export function require<T extends Element = HTMLElement>(
  selector: string,
  scope: ParentNode = document,
): T {
  const el = scope.querySelector<T>(selector);
  if (el === null) {
    throw new Error(`Förväntade ett element som matchar "${selector}".`);
  }
  return el;
}

export const prefersReducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;
